import { render } from "./OnboardingActivity.vue?vue&type=template&id=dd1596f4"
import script from "./OnboardingActivity.vue?vue&type=script&lang=js"
export * from "./OnboardingActivity.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__